// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"_d-z","landingPageVideo":"ae-z","play":"be-z","iframeVideo":"ce-z","playHidden":"de-z","fullwidth":"ee-z"};